module.exports = __webpack_public_path__ + "static/media/colicoli10.de52d496.webp";